export default "__VITE_ASSET__OpmyvmYK__"